import React, { useEffect, useState, useCallback } from 'react';
// import { Document, Page, pdfjs } from 'react-pdf';
// import 'react-pdf/dist/Page/AnnotationLayer.css';
// import 'react-pdf/dist/Page/TextLayer.css';
import serviceApi from '../../../services/serviceApi';
import environment from '../../../environments/environment';
import ExamSchedule from './ExamSchedule';

// PDF.js worker
// pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

// type BackendScheduleRow = {
//   subject: string;
//   maxMrks: string;
//   minMrks: string;
//   date: string;
//   time: string;
//   endTime?: string;
//   status: string;
//   id: string;
// };

type BackendExam = {
  title: string;
  startDate: string;
  endDate: string;
  examType: string;
  // schedules: BackendScheduleRow[];

  knowledgeItem?: {
    id: string;
    title: string;
    description?: string;
    attachmentUrl?: string;
  };
};

type ExamsResponse = {
  status: string;
  message: string;
  dataList?: BackendExam[];
};

const formatRange = (start: string, end: string) => `${start} to ${end}`;

const ExamContent: React.FC = () => {
  const [expandedExamIndex, setExpandedExamIndex] = useState<number | null>(null);
  //const [showResultIndex, setShowResultIndex] = useState<number | null>(null);
  const [exams, setExams] = useState<BackendExam[]>([]);
  // const [examSchedules, setExamSchedules] = useState<Record<number, any[]>>({});
  // const [isScheduleLoading, setIsScheduleLoading] = useState<boolean>(false);
  const [attachmentPopup, setAttachmentPopup] = useState<{ title: string; url: string } | null>(null);
  // const [pdfError, setPdfError] = useState<string | null>(null);
  // const [pdfNumPages, setPdfNumPages] = useState<number | null>(null);
  // const [pdfPageNumber, setPdfPageNumber] = useState<number>(1);
  const [isLoading, setIsLoading] = useState(false);

  const fetchExams = useCallback(async () => {
    setIsLoading(true);
    try {
      const resp = await serviceApi.get<ExamsResponse>(
        environment.exams
      );

      if (resp.status === 'SUCCESS' && Array.isArray(resp.dataList)) {
        setExams(resp.dataList);
      } else {
        setExams([]);
      }
    } catch (error) {
      console.error('Exam API Error:', error);
      setExams([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchExams();
  }, [fetchExams]);

  const handleToggleExpand = (idx: number) => {
    if (expandedExamIndex === idx) {
      setExpandedExamIndex(null);
    } else {
      setExpandedExamIndex(idx);
    }
  };

  // const handleToggleExpand = async (idx: number, examTitle: string) => {
  //   if (expandedExamIndex === idx) {
  //     setExpandedExamIndex(null);
  //     setShowResultIndex(null);
  //     return;
  //   }
  //   setExpandedExamIndex(idx);
  //   if (!examSchedules[idx]) {
  //     setIsScheduleLoading(true);
  //     try {
  //       const response = await serviceApi.get<any>(
  //         `${environment.examschedule}?entityId=${examTitle}`
  //       );
  //       if (response.status === "SUCCESS") {
  //         setExamSchedules(prev => ({
  //           ...prev,
  //           [idx]: response.dataList
  //         }));
  //       }
  //     } catch (err) {
  //       console.error("Error fetching schedule:", err);
  //     } finally {
  //       setIsScheduleLoading(false);
  //     }
  //   }
  // };

  // const handleShowResults = (idx: number) => {
  //   setShowResultIndex(idx);
  // };

  // const handleBackToTimetable = () => {
  //   setShowResultIndex(null);
  // };

  const isPdfFile = (url: string) => {
    const lower = (url || '').toLowerCase();
    return lower.endsWith('.pdf') || lower.includes('pdf');
  };

  const isImageFile = (url: string) => {
    const lower = (url || '').toLowerCase();
    return (
      lower.startsWith('data:image/') ||
      ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'].some(ext => lower.endsWith(ext))
    );
  };

  const openAttachment = (att: { title: string; url: string }) => {
    if (isPdfFile(att.url)) {
      window.open(att.url, '_blank');
      return;
    }
    setAttachmentPopup(att);
  };

  const renderAttachmentPreview = (att: { title: string; url: string }) => {
    if (!att.url) return null;
    if (isPdfFile(att.url)) {
      return (
        <div className="attachment-preview pdf-preview" onClick={() => openAttachment(att)} title={att.title}>
          <i className="fa-solid fa-file-pdf pdf-icon"></i>
        </div>
      );
    }
    if (isImageFile(att.url)) {
      return (
        <div className="attachment-preview image-preview" onClick={() => openAttachment(att)} title={att.title}>
          <img src={att.url} alt={att.title} className="attachment-thumbnail" />
        </div>
      );
    }
  };

  return (
    <>
      <div style={{ padding: "12px 12px 0 12px" }}>
        <h2 className="title-text notification-heading" style={{ margin: 0 }}>
          Exams
        </h2>
      </div>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-overlay__content">
            <div className="spinner spinner--lg"></div>
            <span className="loading-text">Loading exams...</span>
          </div>
        </div>
      )}
      {exams.map((exam, idx) => {
        const expanded = expandedExamIndex === idx;
        //const showResult = showResultIndex === idx;
        // const currentSchedule = examSchedules[idx] || [];

        return (
          <div key={idx} className="event-container" style={{
            marginTop: idx === 0 ? "var(--sz-12)" : "0",
            marginBottom: 'var(--sz-16)'
          }}>
            <ul className="events-list">
              <li className="event-item" style={{ padding: '8px 12px' }}>
                <div className="exam-card-header" style={{ marginBottom: '0px', paddingBottom: '0px' }}>
                  <div className="attachment-section">
                    {exam.knowledgeItem?.attachmentUrl && (
                      renderAttachmentPreview({
                        title: exam.knowledgeItem.title || 'Attachment',
                        url: exam.knowledgeItem.attachmentUrl
                      })
                    )}
                  </div>

                  <div className="exam-title-range" style={{ flex: 1 }}>
                    <strong className="subtitle-text" style={{
                      color: 'var(--colorAccentDark)',
                      display: 'block',
                      lineHeight: '1.1',
                      fontSize: '1rem'
                    }}>{exam.title}</strong>
                    <div className="event-date" style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                      {formatRange(exam.startDate, exam.endDate)}
                    </div>
                  </div>

                  <button
                    className="icon-btn"
                    onClick={() => handleToggleExpand(idx)}
                    style={{ background: 'none', border: 'none', padding: '5px' }}
                  >
                    <i className={`fa-solid ${expanded ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                  </button>
                </div>
                {expanded && (
                  <ExamSchedule
                    entityId={exam.title}
                    // onBack={() => setExpandedExamIndex(null)}
                  />
                )}
                {/* {expanded && (
                  <div className="exam-timetable" style={{ marginTop: '5px', paddingTop: '0px' }}>
                    <div className="table-container" style={{ padding: 0 }}>
                      <div
                        className="table-slider"
                        style={{
                          transform: showResult ? 'translateX(-50%)' : 'translateX(0%)'
                        }}
                      > */}
                {/* TABLE 1: TIMETABLE */}
                {/* <div className="table-wrapper">
                          <div className="table-responsive">
                            <table className="table exam-table" style={{ margin: '0' }}>
                              <thead>
                                <tr>
                                  <th>Subject</th>
                                  <th>Date</th>
                                  <th>Time</th>
                                </tr>
                              </thead>
                              <tbody>
                                {isScheduleLoading && !examSchedules[idx] ? (
                                  <tr><td colSpan={3} style={{ textAlign: 'center' }}><div className="spinner spinner--sm"></div></td></tr>
                                ) : currentSchedule.length > 0 ? (
                                  currentSchedule.map((row, rIdx) => (
                                    <tr key={rIdx}>
                                      <td style={{ fontWeight: '600' }}>{row.subject}</td>
                                      <td>{row.date}</td>
                                      <td>{row.time}{row.endTime ? ` - ${row.endTime}` : ''}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr><td colSpan={3} style={{ textAlign: 'center', padding: '10px' }}>No schedules available</td></tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="table-nav-button right-arrow">
                            <button className="icon-btn" onClick={() => handleShowResults(idx)}>
                              <i className="fa-solid fa-arrow-right"></i>
                            </button>
                          </div>
                        </div> */}

                {/* TABLE 2: RESULTS */}
                {/* <div className="table-wrapper">
                          <div className="table-nav-button left-arrow">
                            <button className="icon-btn" onClick={handleBackToTimetable}>
                              <i className="fa-solid fa-arrow-left"></i>
                            </button>
                          </div>
                          <div className="table-responsive">
                            <table className="table exam-table" style={{ margin: '0' }}>
                              <thead>
                                <tr>
                                  <th>Subject</th>
                                  <th>Max Marks</th>
                                  <th>Pass Marks</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {currentSchedule.map((row, rIdx) => (
                                  <tr key={rIdx}>
                                    <td style={{ fontWeight: '600' }}>{row.subject}</td>
                                    <td>{row.maxMrks}</td>
                                    <td>{row.minMrks}</td>
                                    <td style={{ color: 'var(--colorAccentDark)', fontWeight: '500' }}>{row.status}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
              </li>
            </ul>
          </div>
        );
      })}

      {attachmentPopup && (
        <div className="popup-overlay">
          <div className="popup-box attachment-popup">
            <div className="popup-header">
              <h3 className="popup-title">{attachmentPopup.title}</h3>
              <button className="close-popup-btn" onClick={() => { setAttachmentPopup(null); }}>
                &times;
              </button>
            </div>
            <div className="attachment-popup-content">
              {isImageFile(attachmentPopup.url) ? (
                <img src={attachmentPopup.url} alt={attachmentPopup.title} className="attachment-image" />
              ) : (
                <p>Unsupported file type</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExamContent;